import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./ServiceDescription.css";
import { fixImagePaths } from "../util";
import { useSelector } from "react-redux";
import ServiceSlider from './ServiceSlider';

const ServiceDescription = () => {
  const { title } = useParams(); // Use title from URL
  const [service, setService] = useState(null);
  const [error, setError] = useState(null);
  const { services } = useSelector((state) => state.data);

  useEffect(() => {
    if (Array.isArray(services) && title) {
      // Normalize title for comparison
      const formattedTitle = decodeURIComponent(title).replace(/-/g, ' ').toLowerCase();

      const selectedService = services.find(
        (s) => s.title?.toLowerCase().replace(/\s+/g, ' ') === formattedTitle
      );

      if (selectedService) {
        setService(selectedService);
      } else {
        setError("Service not found.");
      }
    }
  }, [title, services]);

  return (
    <React.Fragment>
      <div className="service-page">
        <div className="modern-service-page">
          <div className="modern-service-card">
            {/* Service Image */}
            <div className="modern-service-image">
              <img
                src={service && service.image}
                alt={service && service.title}
                onError={(e) => {
                  console.error(`Image failed to load: ${e.target.src}`);
                  e.target.src = "/placeholder-image.jpg";
                }}
              />
            </div>

            {/* Service Info */}
            <div className="modern-service-info">
              <h1 className="modern-service-title">{service?.title}</h1>
              {/* Render Description Safely */}
              <div
                className="modern-service-description"
                dangerouslySetInnerHTML={{
                  __html: fixImagePaths(service?.description),
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {service && <ServiceSlider service={service} />}
    </React.Fragment>
  );
};

export default ServiceDescription;